import React from 'react';

import { SVGComponentProps } from './svg.types';

const AlignBottomSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.01675 9.9165C5.5068 9.9165 5.75182 9.9165 5.939 9.82113C6.10361 9.73725 6.23749 9.60337 6.32137 9.43875C6.41675 9.25156 6.41675 9.00656 6.41675 8.5165V2.5665C6.41675 2.07646 6.41675 1.83143 6.32137 1.64426C6.23749 1.47962 6.10361 1.34576 5.939 1.26187C5.75182 1.1665 5.5068 1.1665 5.01675 1.1665H4.90008C4.41003 1.1665 4.16501 1.1665 3.97784 1.26187C3.8132 1.34576 3.67934 1.47962 3.59545 1.64426C3.50008 1.83143 3.50008 2.07646 3.50008 2.5665V8.5165C3.50008 9.00656 3.50008 9.25156 3.59545 9.43875C3.67934 9.60337 3.8132 9.73725 3.97784 9.82113C4.16501 9.9165 4.41003 9.9165 4.90008 9.9165H5.01675ZM12.3959 12.5415C12.6375 12.5415 12.8334 12.3456 12.8334 12.104C12.8334 11.8624 12.6375 11.6665 12.3959 11.6665H1.60425C1.36263 11.6665 1.16675 11.8624 1.16675 12.104C1.16675 12.3456 1.36263 12.5415 1.60425 12.5415H12.3959ZM10.6057 9.82113C10.4185 9.9165 10.1735 9.9165 9.68342 9.9165H9.56675C9.07669 9.9165 8.83169 9.9165 8.6445 9.82113C8.47988 9.73725 8.34601 9.60337 8.26212 9.43875C8.16675 9.25156 8.16675 9.00656 8.16675 8.5165V6.64984C8.16675 6.15978 8.16675 5.91478 8.26212 5.72759C8.34601 5.56295 8.47988 5.4291 8.6445 5.34521C8.83169 5.24984 9.07669 5.24984 9.56675 5.24984H9.68342C10.1735 5.24984 10.4185 5.24984 10.6057 5.34521C10.7703 5.4291 10.9042 5.56295 10.988 5.72759C11.0834 5.91478 11.0834 6.15978 11.0834 6.64984V8.5165C11.0834 9.00656 11.0834 9.25156 10.988 9.43875C10.9042 9.60337 10.7703 9.73725 10.6057 9.82113Z"
        fill="white"
      />
    </svg>
  );
};

export default AlignBottomSVG;
